import useTakerMarketsGroups from '@/enterprise/data/useTakerMarketsGroups';
import { OfferModalWithContext } from '@/enterprise/features/offerModal/OfferModalContext';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import MarketTable from './MarketTable';

const VariableRateMarketTableComponent = () => {
  const {
    BENCHMARK: { takerMarkets },
  } = useTakerMarketsGroups();

  return <MarketTable takerMarkets={takerMarkets} />;
};

const VariableRateMarketTable = () => {
  return (
    <QueryBoundaries>
      <OfferModalWithContext>
        <VariableRateMarketTableComponent />
      </OfferModalWithContext>
    </QueryBoundaries>
  );
};

export default VariableRateMarketTable;
